import React from 'react';
import {
  Box,
  Button,
  Divider,
  EmptyState,
  Heading,
  TextButton,
} from '@wix/design-system';
import * as symbols from '@wix/santa-editor-symbols';
import { translate } from '#packages/i18n';

export interface MemberAuthMigrationBannerProps {
  flow: string;
  onView: () => void;
  onInstall: () => void;
  onLearnMore: () => void;
}

export const MemberAuthMigrationBanner: React.FC<
  MemberAuthMigrationBannerProps
> = ({ flow, onView, onInstall, onLearnMore }) => {
  const lastReportedFlowRef = React.useRef<string | null>(null);
  React.useEffect(() => {
    if (lastReportedFlowRef.current === flow) {
      return;
    }
    lastReportedFlowRef.current = flow;
    onView();
  }, [flow, onView]);

  return (
    <>
      <Divider />
      <Box
        width="432px"
        paddingTop="12px"
        paddingRight="24px"
        paddingBottom="36px"
        paddingLeft="24px"
      >
        <EmptyState
          skin="section"
          image={<symbols.symbol name="memberAuthMigrationIllustration" />}
          title={
            <Heading size="large">
              {translate('member_authentication_app_empty_title')}
            </Heading>
          }
          subtitle={translate('member_authentication_app_empty_description')}
        >
          <Box direction="vertical" gap="SP2" align="center">
            <Box>
              <Button size="small" onClick={onInstall}>
                {translate('member_authentication_app_empty_cta')}
              </Button>
            </Box>
            <TextButton underline="always" size="small" onClick={onLearnMore}>
              {translate('member_authentication_app_empty_learn_more')}
            </TextButton>
          </Box>
        </EmptyState>
      </Box>
      <Divider />
    </>
  );
};
